import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export function useStudentProfile(userId: string | undefined) {
  return useQuery({
    queryKey: ['student-profile', userId ?? ''],
    enabled: !!userId,
    staleTime: 1000 * 60 * 5,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('student_profiles')
        .select('xp, streak_days, level, subjects')
        .eq('id', userId!)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });
}
